exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".columnName:hover {\n  background-color: #deebff; }\n\n.popover-arrow .arrow {\n  display: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/default-column/default-column.component.scss
// module id = ../../../../../src/app/shared/default-column/default-column.component.scss
// module chunks = main